export default __webpack_public_path__ + "static/media/text-block.c09ce1e2.svg";